<h1 class="text-center">Veelgestelde vragen</h1>

<div class="[ max-w-4xl w-full ] [ stack stack-space-3xl items-center ]">
  <campus-maintenance-mode
    *ngIf="isMaintenanceMode$ | async; else operationalMode"
    [statusPageUrl]="statusPageUrl"
    class="[ m-b-m ]"
  ></campus-maintenance-mode>

  <ng-template #operationalMode>
    <section class="[ m-b-m ]">
      <ng-container *ngIf="selectedRole$ | async as role">
        <campus-chip-group class="[ flex justify-center ]">
          <campus-filter-chip
            label="voor leerlingen"
            [selected]="role === 'student'"
            (click)="roleClicked('student')"
          ></campus-filter-chip>

          <campus-filter-chip
            label="voor leerkrachten"
            [selected]="role === 'teacher'"
            (click)="roleClicked('teacher')"
          ></campus-filter-chip>

          <campus-filter-chip
            label="voor schoolbeheerders"
            [selected]="role === 'schooladmin'"
            (click)="roleClicked('schooladmin')"
          ></campus-filter-chip>
        </campus-chip-group>
      </ng-container>
    </section>

    <ng-container *ngIf="filteredFaqCategories$ | async as faqCategories">
      <section class="[ reel reel-item-h-3xs reel-item-w-3xs overflowing max-w-full ]">
        <dcr-card
          *ngFor="let faqCategory of faqCategories; trackBy: trackById"
          type="button"
          [headline]="faqCategory.name"
          (click)="categoryClicked(faqCategory)"
          hero-type="image"
        >
          <dcr-image [src]="faqCategory.icon" [alt]="faqCategory.name" slot="hero"></dcr-image>
        </dcr-card>
      </section>
      <div class="p-be-3xl">
        <section class="[ stack stack-space-3xl ]">
          <ng-container *ngFor="let faqCategory of faqCategories; trackBy: trackById">
            <section>
              <div class="[ stack stack-space-3xs ]">
                <ng-container *ngIf="faqCategory.questions">
                  <h2 [attr.id]="faqCategory.slug">{{ faqCategory.name }}</h2>
                  <dcr-section
                    *ngFor="let question of faqCategory.questions; trackBy: trackBySlug"
                    [attr.id]="question.slug"
                    [headline]="question.question"
                    [open]="(currentSlug$ | async) === question.slug"
                    [outline]="(currentSlug$ | async) === question.slug"
                  >
                    <dcr-inline-icon-button
                      [icon]="(copied$ | async) === question.slug ? 'portal:copied' : 'portal:link'"
                      slot="leading-image"
                      (click)="copyLink(question.slug, $event)"
                      aria-label="Kopieer link"
                    ></dcr-inline-icon-button>
                    <div [innerHTML]="question.answer" class="body-large"></div>
                    <campus-video-player
                      class="[ block ] [ m-bs-m ]"
                      *ngIf="question.videoId"
                      [videoId]="question.videoId"
                      [player]="question.videoPlayer || videoPlayer"
                    ></campus-video-player>
                  </dcr-section>
                </ng-container>
              </div>
            </section>
          </ng-container>
        </section>
      </div>

      <dcr-tonal-icon-button
        *ngIf="windowScrolled$ | async"
        (click)="scrollToTop()"
        class="[ index-fab ] [ sticky bottom-xl self-end -right-m ] [ transform translate-x-1/2 elevation-4 ]"
        icon="portal:up"
      >
      </dcr-tonal-icon-button>
    </ng-container>
  </ng-template>
</div>
